import clsx from 'clsx'
import React from 'react'

import { HeartFilled } from '@Components/SVG/Cache'

import styles from './WishlistButton.module.scss'

export const WishlistButton = ({
  animated = true,
  className,
  label,
  selected,
  small,
  ...rest
}: {
  animated?: boolean
  label?: string
  selected: boolean
  small?: boolean
} & React.ComponentProps<'button'>) => (
  <button
    aria-label={label}
    className={clsx(
      styles.wishlistButton,
      className,
      small && styles.small,
      !small && styles.default,
    )}
    type="button"
    {...rest}
  >
    <div className={styles.box}>
      <HeartFilled className={clsx(styles.heart, selected && styles.selectedHeart, selected && 'selectedHeart', animated && styles.animated)} />
    </div>
  </button>
)
